import React from "react";
import { Link } from "react-router-dom";
import { IMGS } from "../../lib/api";

export const Heritage = () => (
  <section className="py-12 sm:py-16" data-testid="heritage-section">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 grid lg:grid-cols-2 gap-12 lg:gap-20 items-center">
      <div className="relative">
        <div className="aspect-[4/5] overflow-hidden">
          <img src={IMGS.weave} alt="Handloom weaving an Ilkal saree" loading="lazy" className="w-full h-full object-cover" />
        </div>
        <div className="absolute -bottom-8 -right-4 sm:-right-8 w-40 sm:w-56 aspect-square overflow-hidden border-4 border-ivory shadow-xl">
          <img src={IMGS.texture} alt="Close-up of Ilkal weave and border" loading="lazy" className="w-full h-full object-cover" />
        </div>
      </div>
      <div className="lg:pl-4">
        <p className="uppercase tracking-[0.25em] text-xs font-semibold text-gold">Our Heritage</p>
        <h2 className="font-heading text-2xl sm:text-3xl lg:text-4xl tracking-tight font-medium text-charcoal mt-3 leading-tight" data-testid="heritage-heading">
          WOVEN IN ILKAL. ROOTED IN TRADITION.
        </h2>
        <p className="text-base leading-relaxed text-charcoal/70 mt-6">
          For centuries, the weavers of Ilkal in North Karnataka have produced sarees known across India for their distinctive temple borders, contrast pallus and sturdy, honest weave. Every R V Ilkal saree comes directly from these looms to you — no middlemen, no imitations.
        </p>
        <p className="text-base leading-relaxed text-charcoal/70 mt-4">
          We work hand in hand with weaving families in Ilkal, celebrating the traditional craftsmanship and the unique Ilkal weave while bringing authentic handloom sarees to wardrobes across the country.
        </p>
        <Link
          to="/about"
          data-testid="heritage-story-btn"
          className="inline-block mt-8 border border-gold text-charcoal px-8 py-3.5 text-xs tracking-[0.2em] uppercase hover:bg-gold/10 transition-colors"
        >
          Read Our Story
        </Link>
      </div>
    </div>
  </section>
);
